module.exports = __webpack_public_path__ + "static/media/yellow_button.cf004c58.png";